/**
 * Demo / offline shapes for Progress page when REACT_APP_PROGRESS_MOCK=true
 * or when live API calls fail.
 */

export const MOCK_LEARNING_INSIGHTS = {
  weak_topics: [
    {
      topic: 'Recursion',
      questions_total: 6,
      questions_correct: 2,
      questions_wrong: 4,
      correct_rate: 33.3,
      avg_score: 42,
      missing_points: ['base case', 'stack frames'],
      last_attempted: new Date().toISOString(),
      review_session_ids: ['r1'],
    },
  ],
  confusion_patterns: [
    {
      topic: 'Pointers',
      confusion_count: 4,
      resolved_count: 1,
      helpful_rate: 100,
      sample_confusions: [
        { id: 'm1', confusion_text: 'Why does dereferencing change the value?', resolved: false },
      ],
    },
  ],
  strengths: [
    {
      topic: 'Sorting',
      questions_total: 8,
      questions_correct: 7,
      questions_wrong: 1,
      correct_rate: 87.5,
      avg_score: 88,
      missing_points: [],
      last_attempted: new Date().toISOString(),
      review_session_ids: ['r2'],
    },
  ],
  insights: [],
  total_questions_answered: 24,
  total_confusion_logs: 6,
  overall_correct_rate: 71,
};

export const MOCK_CONFUSION_LOGS = [
  {
    id: 'cl-m1',
    topic: 'Pointers',
    confusion_text: 'Still fuzzy on double pointers vs arrays of pointers',
    resolved: false,
    created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
    subject_id: null,
  },
  {
    id: 'cl-m2',
    topic: 'Memory',
    confusion_text: 'When is malloc preferable to stack allocation?',
    resolved: false,
    created_at: new Date(Date.now() - 86400000).toISOString(),
    subject_id: null,
  },
];

export const MOCK_STUDY_DASHBOARD = {
  priorities: [
    {
      subject_id: 's-mock-1',
      subject_name: 'CS 201',
      course_code: 'CS201',
      color: '#6366f1',
      priority_score: 62,
      breakdown: { exam_urgency: 40, days_since_study: 12, review_weakness: 10 },
    },
    {
      subject_id: 's-mock-2',
      subject_name: 'Linear Algebra',
      course_code: 'MATH220',
      color: '#0ea5e9',
      priority_score: 38,
      breakdown: { exam_urgency: 10, days_since_study: 4, review_weakness: 24 },
    },
  ],
  upcoming_exams: [],
  recommendation: null,
  exams_needing_scores: [],
};
